export function HandleMenuActiveManual(location: string, setSelectedMenu: any) {
  if (
    location === "/dashboard" ||
    location === "/update-password" ||
    location === "/update-profile"
  ) {
    setSelectedMenu("");
  } else {
    let splitedLocations = location.split("/");
    let url = splitedLocations[1];
    let navigation = [
      {
        name: "customers",
        menuName: "Customers",
      },
      {
        name: "user",
        menuName: "Manage Users",
      },
      {
        name: "new-lead",
        menuName: "New Lead",
      },
      {
        name: "leads",
        menuName: "Leads",
      },
      {
        name: "jobs",
        menuName: "Jobs",
      },
    ];
    navigation.map((nav: any) => {
      if (url === nav.name) {
        setSelectedMenu(nav.menuName);
      }
    });
  }
}

export function handleCustomerMenuManual(
  location: any,
  setCustomerSelectedMenu: any
) {
  if (location === "all-leads") {
    setCustomerSelectedMenu("All Leads");
  } else if (location === "hot-leads") {
    setCustomerSelectedMenu("High Intent Leads");
  } else if (location === "warm-leads") {
    setCustomerSelectedMenu("Medium Intent Leads");
  } else if (location === "interested-leads") {
    setCustomerSelectedMenu("Low Intent Leads");
  }
}
